/**
 * Totais do pedido vindos de GET /:companyId/orders/:orderId.
 *
 * A API já normaliza `discount` em REAIS (order.service → vlrDiscount), tanto
 * para desconto percentual quanto para o legado. Não multiplicar por
 * amount/100 — era isso que zerava o desconto na tela de itens.
 */
export function orderDiscount(data) {
  return Number(data?.discount) || 0;
}

export function orderFreight(data) {
  const frete = Number(data?.delivery?.VlTotal) || 0;
  return frete > 0 ? frete : 0;
}

/** Subtotal - desconto + frete (sem cashback) */
export function orderNetValue(data) {
  if (!data) return 0;
  return (Number(data.amount) || 0) - orderDiscount(data) + orderFreight(data);
}

/** Valor líquido - cashback utilizado */
export function orderTotal(data) {
  if (!data) return 0;
  return orderNetValue(data) - (Number(data.cashback) || 0);
}
